import Axios from 'axios';
import Cookies from 'js-cookie';

import AppConfig from 'config/App';

const token = window.HEXURE_UQ_CONFIG && window.HEXURE_UQ_CONFIG.id;

const request = Axios.create({
  baseURL: AppConfig.HEALTH_ANALYZER_BASE_URL,
  headers: {
    Accept: 'application/json'
  }
});

const HealthAnalyzerApi = {
  // helper to apply auth headers to the request instance
  _applyAuthHeaders(ixn_auth = {}) {
    if (token) request.defaults.headers['Universal-QUOTER-TOKEN'] = token;
    request.defaults.headers['access-token'] = ixn_auth.access_token;
    request.defaults.headers['client'] = ixn_auth.client;
    request.defaults.headers['uid'] = ixn_auth.uid;
    request.defaults.headers['x-api-key'] = ixn_auth.ha_api_token;
  },

  getCarriers(config = {}) {
    const ixn_auth = Cookies.getJSON('ixn') || {};
    this._applyAuthHeaders(ixn_auth);
    return request.get('/GetCarriers', config).then(response => response.data);
  },

  postHealthAnalyzerForm(params) {
    const ixn_auth = Cookies.getJSON('ixn') || {};
    this._applyAuthHeaders(ixn_auth);
    return request.post('/ProcessHealthClass', params).then(response => response.data);
  }
};

export default HealthAnalyzerApi;
